export enum GuestTypeSource {
  Undefined = 'Undefined',
  User = 'User',
  SecurityOfficer = 'SecurityOfficer',
  Resident = 'Resident',
  Imported = 'Imported',
  EIQVoice = 'EIQVoice',
}
